import * as Service from './service';
import * as Domain from './domain'
import * as Serialization from './tracking/serialization';

export const practiceSessionModules = [
  Service.practiceSessionServiceModule,
  Domain.practiceSessionDomainModule
]
